import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  type ConnectionListResponse,
  type ConnectionResponse,
  type GenerateFormSuccessResponse,
} from '../features/DiscoverCMDBApps/data-layer/ApplicationCard';
import { type ApplicationTypeMetadataTransformed } from '../features/ManageCMDBDiscoveredApps/data-layer/aaplicationTypeMetadataTypes';

export interface GlobalState {
  manageCMDBDiscoveredAppsHeaderDetails?: ApplicationTypeMetadataTransformed;
  generateTemplateDetails?: GenerateFormSuccessResponse;
  discoveryConnectionListResults?: ConnectionListResponse;
  existingConnectionDetails?: ConnectionResponse;
}

const initialState: GlobalState = {
  manageCMDBDiscoveredAppsHeaderDetails: undefined,
  generateTemplateDetails: undefined,
  discoveryConnectionListResults: undefined,
  existingConnectionDetails: undefined,
};

export const globalSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    setManageCMDBDiscoveredAppsHeader: (
      state,
      action: PayloadAction<ApplicationTypeMetadataTransformed>
    ) => ({
      ...state,
      manageCMDBDiscoveredAppsHeaderDetails: action.payload,
    }),
    setGenerateTemplateResult: (
      state,
      action: PayloadAction<GenerateFormSuccessResponse>
    ) => ({
      ...state,
      generateTemplateDetails: action.payload,
    }),
    setDiscoveryConnectionListResult: (
      state,
      action: PayloadAction<ConnectionListResponse>
    ) => ({
      ...state,
      discoveryConnectionListResults: action.payload,
    }),
  },
});

export const {
  setManageCMDBDiscoveredAppsHeader,
  setGenerateTemplateResult,
  setDiscoveryConnectionListResult,
} = globalSlice.actions;

export const globalActions = {
  setManageCMDBDiscoveredAppsHeader,
  setGenerateTemplateResult,
  setDiscoveryConnectionListResult,
};
